import { RigidBody, type CollisionEnterPayload } from '@react-three/rapier';
import { useRef } from 'react';
import { useGame } from './score-context';
import { Mesh } from 'three';

const pinColor = 0x888888;

export function Pin({ position }: { position: [number, number, number] }) {
  const { score, setScore, balls, setBalls } = useGame();

  // Add very slight random rotation to each pin to break symmetry
  const randomRotation = (Math.random() - 0.5) * 0.05;

  const timeoutRef = useRef<number>();

  return (
    <RigidBody
      type="fixed"
      position={position}
      colliders="ball"
      enabledTranslations={[true, true, false]}
      enabledRotations={[false, false, true]}
      rotation={[0, 0, randomRotation]}
      onCollisionEnter={({ manifold, target, other }) => {
        setScore(score + 10);

        const mesh = target.colliderObject?.parent?.children[0];
        if (mesh && mesh instanceof Mesh) {
          mesh.material.color.setHex(0xffffff);

          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          timeoutRef.current = setTimeout(() => {
            mesh.material.color.setHex(pinColor);
          }, 1000);
        }
      }}
    >
      <mesh castShadow receiveShadow>
        <sphereGeometry args={[0.25, 32, 32]} />
        <meshStandardMaterial color={pinColor} metalness={0.2} roughness={0.2} />
      </mesh>
    </RigidBody>
  );
}
